import React from "react";

import { Access } from "common";
import { Form } from "components";
import {
  Stores,
  Channels,
  Discounts,
  Campaigns,
  Benefits,
  Regions,
} from "components/Filters";

export default function Filters({ data, disabled, onChange, onClean, onSubmit }) {
  const benefitFilters = {
    date_start: data.date_start,
    date_end: data.date_end,
    discount: data.discount,
    campaign: data.campaign,
    channels: data.channels,
    stores: data.stores,
    regions: data.regions,
  };

  const storeFilters = { regions: data.regions };

  return (
    <Form className="row form-filters">
      <Form.Field className="col-md-3">
        <Form.Label>Regiões</Form.Label>
        <Regions
          value={data.regions}
          onChange={(value) => onChange("regions", value)}
          isMulti
        />
      </Form.Field>

      <Form.Field className="col-md-3">
        <Form.Label>Lojas</Form.Label>
        <Stores
          isMulti
          value={data.stores}
          onChange={(value) => onChange("stores", value)}
          isDisabled={!!Access.lockedStore()}
          filters={storeFilters}
        />
      </Form.Field>

      <Form.Field className="col-md-3">
        <Form.Label>Período, de</Form.Label>
        <Form.Icon name="calendar">
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={data.date_start}
            onChange={(value) => onChange("date_start", value)}
          />
        </Form.Icon>
      </Form.Field>

      <Form.Field className="col-md-3">
        <Form.Label>Período, até</Form.Label>
        <Form.Icon name="calendar">
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={data.date_end}
            onChange={(value) => onChange("date_end", value)}
            minDate={data.date_start}
            disabled={data.date_start === null}
          />
        </Form.Icon>
      </Form.Field>

      <Form.Field className="col-md-7">
        <Form.Label>Descontos</Form.Label>
        <Discounts
          value={data.discount}
          onChange={(value) => onChange("discount", value)}
        />
      </Form.Field>

      <Form.Field className="col-md-5">
        <Form.Label>Canais</Form.Label>
        <Channels
          value={data.channels}
          onChange={(value) => onChange("channels", value)}
        />
      </Form.Field>

      <Form.Field className="col-md-4">
        <Form.Label>Campanha Comercial</Form.Label>
        <Campaigns
          value={data.campaign}
          onChange={(value) => onChange("campaign", value)}
        />
      </Form.Field>

      <Form.Field className="col-md-4">
        <Form.Label>Benefícios</Form.Label>
        <Benefits
          value={data.voucher_id}
          onChange={(value) => onChange("voucher_id", value)}
          filters={benefitFilters}
        />
      </Form.Field>

      <Form.Field
        className="col-md-4"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
        }}
      >
        <Form.Button className="button-clean-filter" onClick={onClean}>
          Resetar Filtro
        </Form.Button>

        <Form.Button
          disabled={disabled}
          className="button-apply-filter"
          onClick={onSubmit}
        >
          Aplicar Filtro
        </Form.Button>
      </Form.Field>
    </Form>
  );
}
